module.exports = __webpack_public_path__ + "img/guide1.7fbc2889.png";